import { CreateProvisionWasm } from "@pdfking/wasm-core"
import wasm32 from "../wasm/pdfium.wasm"
import { Functions } from "./Functions"

export const ProvisionWasm = CreateProvisionWasm(
  wasm32,
  { init: instance => Functions.init(instance) },
  Functions
)
